module.exports = __webpack_public_path__ + "static/media/premium.5768fd39.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/NoAccess/premium.png
// module id = 1074
// module chunks = 0